import { inferWalletTxnChannel, inferWalletTxnStatus } from '../ledger/mapWalletTransactions';

export function computeReconciliationSummary(transactions = [], inferChannel, inferStatus) {
  const channelFn = inferChannel || inferWalletTxnChannel;
  const statusFn = inferStatus || inferWalletTxnStatus;

  let totalCredits = 0;
  let totalDebits = 0;
  let creditCount = 0;
  let debitCount = 0;
  let failedCount = 0;
  let reversedCount = 0;
  let walletRecharge = 0;
  let bookingAdvance = 0;
  let capturedCount = 0;

  (transactions || []).forEach((tx) => {
    const amount = Math.abs(Number(tx.amount || 0));
    const type = String(tx.type || '').toLowerCase();
    const channel = channelFn(tx);
    const status = statusFn(tx);

    if (type === 'credit') {
      totalCredits += amount;
      creditCount += 1;
    } else {
      totalDebits += amount;
      debitCount += 1;
    }

    if (status === 'failed') failedCount += 1;
    if (status === 'reversed') reversedCount += 1;
    if (status === 'captured') capturedCount += 1;
    if (channel === 'wallet_recharge') walletRecharge += amount;
    if (channel === 'booking_advance') bookingAdvance += amount;
  });

  return {
    count: transactions.length,
    totalCredits,
    totalDebits,
    netBalance: totalCredits - totalDebits,
    creditCount,
    debitCount,
    failedCount,
    reversedCount,
    capturedCount,
    walletRecharge,
    bookingAdvance,
    grossVolume: totalCredits + totalDebits,
  };
}
